export const QLINE_CLOUD_ORIGIN = 'https://qlinethegame.com';

export function isLoopbackLocation(locationLike = globalThis.location) {
  return ['127.0.0.1', 'localhost'].includes(String(locationLike?.hostname || '').toLowerCase());
}

export function sessionOrigin(locationLike = globalThis.location, production = Boolean(import.meta.env?.PROD)) {
  const mode=globalThis.document?.querySelector?.('meta[name="qline-room-service"]')?.content;
  if(mode==='local-recordings' && /^https?:\/\//.test(String(locationLike?.origin||'')))return String(locationLike.origin).replace(/\/$/,'');
  if (production && canRelayPrivateVoices(locationLike)) return QLINE_CLOUD_ORIGIN;
  return String(locationLike?.origin || QLINE_CLOUD_ORIGIN).replace(/\/$/, '');
}

export function sessionApiUrl(path, locationLike = globalThis.location, production = Boolean(import.meta.env?.PROD)) {
  return `${sessionOrigin(locationLike, production)}${path.startsWith('/') ? path : `/${path}`}`;
}

export function sessionSocketUrl(identity, locationLike = globalThis.location, production = Boolean(import.meta.env?.PROD)) {
  const origin = new URL(sessionOrigin(locationLike, production));
  origin.protocol = origin.protocol === 'https:' ? 'wss:' : 'ws:';
  origin.pathname = `/api/rooms/${encodeURIComponent(identity.roomCode)}/ws`;
  origin.search = new URLSearchParams({ token: identity.token }).toString();
  return origin.href;
}

export function canRelayPrivateVoices(locationLike = globalThis.location) {
  // Only the existing Director server owns the bundled speech engine. A local
  // Worker preview is still an ordinary browser and must use its own rooms.
  return isLoopbackLocation(locationLike) && new URL(locationLike.origin).port === '4317';
}
